import { Expose } from 'class-transformer';
import { Model } from './model';

export class DependentReport extends Model {
  @Expose() availableDurationInMin: string;
  @Expose() dependentId: string;
  @Expose() dependentName: string;
  @Expose() parentId: string;
  @Expose() parentName: string;
  @Expose() totalConsumedInMin: string;
  @Expose() totalDurationInMin: string;
}
